import { updateUserTrustedContactSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';

const TrustedContactForm = ({ onFinish, submitLabel }) => {
  const { user, api } = useAuth();

  return (
    <ValidatedForm
      key="userTrustedContact"
      schema={updateUserTrustedContactSchema}
      initialValues={{ trustedContact: user.trustedContact }}
      handleSubmit={api.updateUserTrustedContact}
      onFinish={onFinish}
    >
      <FormInput name="trustedContact.name.givenName" type="text" />
      <FormInput name="trustedContact.name.familyName" type="text" />
      <FormInput name="trustedContact.email" type="email" />
      <FormInput name="trustedContact.phoneNumber" type="text" />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export default TrustedContactForm;
